import React, { useState } from 'react';

import BlurPopup from 'components/BlurPopup';
import { Button } from 'components/Buttons/Button';
import { NotificationIcon, WarningIcon } from 'assets/icons';

import styles from './MessageFromHfsPopup.module.scss';

interface MessageFromHfsPopupProps {
  isOpen: boolean;
  mainMessage: string;
  onClose: () => void;
  additionalMessage?: string;
}

const MessageFromHfsPopup = ({ isOpen, mainMessage, additionalMessage, onClose }: MessageFromHfsPopupProps) => {
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  return (
    <BlurPopup
      id="popup"
      classes={{
        paper: styles.paper,
        container: styles.container,
      }}
      onClose={() => {}}
      open={isOpen}
      scroll="body"
      blurDeep={2}
    >
      <>
        <div className={styles.header}>You have new message from HFS</div>
        <div className={styles.messageContainer}>
          <WarningIcon />
          <a className={styles.message}>{mainMessage}</a>
        </div>
        {additionalMessage && (
          <div className={styles.messageContainer}>
            <NotificationIcon />
            <a className={styles.message}>{additionalMessage}</a>
          </div>
        )}
        <div className={styles.buttonsContainer}>
          <Button
            onClick={async () => {
              setIsButtonLoading(true);
              await onClose();
              setIsButtonLoading(false);
            }}
            isLoading={isButtonLoading}
          >
            Mark as Read
          </Button>
        </div>
      </>
    </BlurPopup>
  );
};

export default MessageFromHfsPopup;
